export default __webpack_public_path__ + "static/media/rock.bb345596.jpg";